import { useSelector } from "react-redux"
import { Box, Typography } from "@mui/material"
import DashboardLayout from "../components/DashboardLayout"
import AdminDashboard from "../components/dashboard/AdminDashboard"
import ResellerDashboard from "../components/dashboard/ResellerDashboard"
import UserDashboard from "../components/dashboard/UserDashboard"

const DashboardPage = () => {
  const { userInfo } = useSelector((state) => state.auth)

  return (
    <DashboardLayout>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Welcome back, {userInfo?.user.name}!
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Here's an overview of your WhatsApp campaigns and performance metrics.
        </Typography>
      </Box>

      {userInfo?.user.role === "admin" && <AdminDashboard />}
      {userInfo?.user.role === "reseller" && <ResellerDashboard />}
      {userInfo?.user.role === "user" && <UserDashboard />}
    </DashboardLayout>
  )
}

export default DashboardPage

